export const ricsterTerms = {
  effectiveDate: 'July 1, 2024',
  contents: [
    {
      header: '1. Acceptance of Terms',
      body: [
        'Welcome to Ricster. These terms of Service (“Terms”) govern your use of our mobile application (the “App”) provided by ATCREATE Inc (“we”, “us”, or “our”). By downloading, installing, or using the App, you agree to be bound by these Terms of Service ("Terms") and our Privacy Policy. If you do not agree with these Terms, please do not use the App.',
      ],
    },
    {
      header: '2. Use of the App',
      body: [],
    },
    {
      header: '2.1 Eligibility',
      body: [
        'To use the App, you must be at least 18 years old to use the App. By using the App, you represent and warrant that you meet this age requirement.',
      ],
    },
    {
      header: '2.2 License',
      body: [
        'We grant you a limited, non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial use, subject to these Terms. You may not use the App for any other purpose without our prior written consent.',
      ],
    },
    {
      header: '3. User Conduct',
      body: [
        'You agree not to:',
        '•	Use the App for any illegal purpose or in violation of any local, state, national, or international law.',
        '•	Harass, threaten, demean, embarrass, or otherwise harm any other user of the App.',
        '•	Violate, misappropriate, or infringe the rights of others, including privacy, publicity, intellectual property, or other proprietary rights.',
        '•	Interfere with the operation of the App or any user’s enjoyment of the App, including by uploading or otherwise disseminating viruses, adware, spyware, worms, or other malicious code.',
        '•	Collect or store personal information about other users without their consent.',
        '•	Engage in any conduct that disrupts or impedes the functionality of the App.',
        '•	Reverse engineer, decompile, disassemble, or otherwise attempt to discover the source code of the App or any part thereof.',
        '•	Rent, lease, lend, sell, redistribute, or sublicense the App.',
      ],
    },
    {
      header: '4. Account Registration',
      body: [],
    },
    {
      header: '4.1 Account Creation',
      body: [
        'To access certain features of the App, you may need to register to an account. When you register, you agree to provide accurate, current and complete Information about yourself.',
      ],
    },
    {
      header: '4.2 Account Security',
      body: [
        'You are responsible for maintaining the confidentiality of your account login information and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.',
      ],
    },
    {
      header: '5. Intellectual Property',
      body: [
        'All content and materials available on the App, including but not limited to text, graphics, logos, and software, are the property of ATCREATE Inc. or its licensors and are protected by copyright, trademark, and other intellectual property laws. You agree not to reproduce, distribute, or create derivative works from any content on the App without our prior written consent.',
      ],
    },
    {
      header: '6. In-App Purchases',
      body: [
        'The App may offer in-app purchases. All in-app purchases are final and non-refundable, except as required by applicable law. We reserve the right to manage, regulate, or eliminate in-app purchases at our sole discretion.',
      ],
    },
    {
      header: '7. Termination',
      body: [
        'We may terminate or suspend your access to the App at any time, with or without cause or notice, if you breach these Terms or for any other reason. Upon termination, your right to use the App will immediately cease.',
      ],
    },
    {
      header: '8. Disclaimers',
      body: [
        'The App is provided on an "as-is" and "as-available" basis. We make no warranties, express or implied, regarding the App, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.',
      ],
    },
    {
      header: '9. Limitation of Liability',
      body: [
        'To the fullest extent permitted by law, ATCREATE Inc. and its affiliates, officers, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from your use of the App.',
      ],
    },
    {
      header: '11. Indemnification',
      body: [
        'You agree to indemnify, defend, and hold harmless ATCREATE Inc. land our officers, directors, employees, and agents from and against any claims, liabilities, damages, losses and expenses, including without limitation, reasonable legal and accounting fees, arising out of or in any way connected with your access to or use of the App or your violation of these Terms',
      ],
    },
    {
      header: '12. Governing Law',
      body: [
        'These Terms shall be governed by and construed in accordance with the laws of the Province of Alberta, Canada, without regard to its conflict of law principles. Any legal action or proceeding arising under these Terms shall be brought exclusively in the federal or provincial courts located in Calgary, Alberta, Canada.',
      ],
    },
    {
      header: '13. Changes to Terms',
      body: [
        'We reserve the right to modify these Terms at any time. We will notify you of any changes by updating the "Effective Date" at the top of these Terms. Your continued use of the App after any such changes constitutes your acceptance of the new Terms.',
      ],
    },
    {
      header: '14. Contact Us',
      body: ['If you have any questions about these Terms, please contact us at support@atcreate.ca.'],
    },
  ],
}
